import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { UtilsContext } from './context';
/**
 * UtilsProvider
 * @param {UtilsProviderProps} props
 * @returns {JSX.Element}
 * @constructor
 * @example
 * <UtilsProvider
 *  formatDate={formatDate}
 * transformDate={transformDate}
 * dateHelpers={dateHelpers}
 * assets={assets}
 * >
 * <App />
 * </UtilsProvider>

 */
export const UtilsProvider = (props) => {
    const { formatDate, transformDate, dateHelpers, children, assets } = props;
    return (_jsx(UtilsContext.Provider, { value: {
            assets,
            formatDate,
            transformDate,
            dateHelpers,
        }, children: children }));
};
export const useUtilsProvider = () => {
    const utilsContext = useContext(UtilsContext);
    if (!utilsContext) {
        throw Error('UtilsProvider not initialized. Need to render <UtilsProvider> and configure each utility');
    }
    return { ...utilsContext };
};
//# sourceMappingURL=provider.js.map